/**
 * BlogSearchResultsBar - results-count bar shown above blog search results.
 * Custom element: <blog-search-results-bar>
 *
 * Refs:
 *   [data-ref="backButton"]  (required)
 *   [data-ref="resultsText"]  (required)
 *   [data-ref="resultsCount"]  (required)
 *   [data-ref="resultsLabel"]  (required)
 *   [data-ref="searchTerm"]  (required)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class BlogSearchResultsBar extends ThemeComponent {
  init() {
    this.backButton && this.backButton.addEventListener("click", () => {
      this.clearSearch();
    }), this.updateResults(), this.observeArticlesContainer();
  }
  observeArticlesContainer() {
    const blogMain = document.querySelector("blog-main");
    if (!blogMain) {
      setTimeout(() => this.observeArticlesContainer(), 500);
      return;
    }
    const articlesContainer = blogMain.querySelector(".blog-main__articles");
    if (!articlesContainer) {
      setTimeout(() => this.observeArticlesContainer(), 500);
      return;
    }
    new MutationObserver(() => {
      this.updateResults();
    }).observe(articlesContainer, {
      childList: !0,
      subtree: !0
    }), window.addEventListener("popstate", () => {
      this.updateResults();
    }), window.addEventListener("hashchange", () => {
      this.updateResults();
    });
  }
  updateResults() {
    const searchQuery = new URLSearchParams(window.location.search).get("q");
    if (!searchQuery || searchQuery.trim() === "") {
      this.style.display = "none";
      return;
    }
    window.matchMedia("(min-width: 768px)").matches ? this.style.display = "block" : this.style.display = "none";
    const blogMain = document.querySelector("blog-main"),
      articlesContainer = blogMain == null ? void 0 : blogMain.querySelector(".blog-main__articles"),
      resultCount = ((articlesContainer == null ? void 0 : articlesContainer.querySelectorAll(".blog-main__article-item")) || []).length;
    this.resultsCount && (this.resultsCount.textContent = resultCount.toString()), this.resultsLabel && (this.resultsLabel.textContent = resultCount === 1 ? "Article Found" : "Articles Found"), this.searchTerm && (this.searchTerm.textContent = searchQuery);
  }
  async clearSearch() {
    const blogSearch = document.querySelector("blog-search");
    if (blogSearch && blogSearch.clearSearch) await blogSearch.clearSearch();else {
      const blogMain = document.querySelector("blog-main");
      if (!blogMain) return;
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("q"), cleanUrl.searchParams.delete("page"), window.history.pushState({}, "", cleanUrl.toString()), blogMain.articles && (await blogMain.articles());
    }
    this.updateResults();
  }
}
setFunctionName(BlogSearchResultsBar, "BlogSearchResultsBar");
const propertyTypes = {};
BlogSearchResultsBar.prototype.$name = "BlogSearchResultsBar";
BlogSearchResultsBar.prototype.$info = JSON.parse('{"name":"BlogSearchResultsBar","meta":{"isLegacy":false,"selector":"blog-search-results-bar"},"props":[],"refs":[{"selector":"[data-ref=\\"backButton\\"]","required":true,"propertyKey":"backButton","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLButtonElement"},{"selector":"[data-ref=\\"resultsText\\"]","required":true,"propertyKey":"resultsText","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"},{"selector":"[data-ref=\\"resultsCount\\"]","required":true,"propertyKey":"resultsCount","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"},{"selector":"[data-ref=\\"resultsLabel\\"]","required":true,"propertyKey":"resultsLabel","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"},{"selector":"[data-ref=\\"searchTerm\\"]","required":true,"propertyKey":"searchTerm","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"}]}');
BlogSearchResultsBar.prototype.$info.component = BlogSearchResultsBar;
for (const prop of BlogSearchResultsBar.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Blog/BlogSearchResultsBar.ts", {
  BlogSearchResultsBar: BlogSearchResultsBar
}, void 0);